<div class="message-templates-settings">
  <h1>{{ 'SETTINGS.MESSAGE_TEMPLATES.TITLE' | translate }}</h1>

  <div class="actions">
    <orbit-button
      [icon]="addIcon"
      label="{{ 'SETTINGS.MESSAGE_TEMPLATES.ADD_TEMPLATE' | translate }}"
      (click)="addMessageTemplate()"></orbit-button>
  </div>

  @let loadingValue = loading();
  @let errorValue = error();
  <!-- Loading indicator -->
  @if (loadingValue) {
    <div class="loading-container">
      <p>{{ 'SETTINGS.MESSAGE_TEMPLATES.LOADING' | translate }}</p>
    </div>
  }

  <!-- Error message -->
  @if (errorValue) {
    <div class="error-container">
      <p class="error-message">{{ errorValue }}</p>
    </div>
  }

  @let messageTemplatesValue = messageTemplates();
  <!-- Message templates table -->
  @if (!loadingValue && !errorValue && messageTemplatesValue && messageTemplatesValue.length > 0) {
    <div class="templates-table-container">
      <table class="templates-table">
        <thead>
          <tr>
            <th>{{ 'SETTINGS.MESSAGE_TEMPLATES.NAME' | translate }}</th>
            <th>{{ 'SETTINGS.MESSAGE_TEMPLATES.DESCRIPTION' | translate }}</th>
            <th>{{ 'SETTINGS.MESSAGE_TEMPLATES.LANGUAGES_TEXT' | translate }}</th>
            <th>{{ 'SETTINGS.MESSAGE_TEMPLATES.PARAMETERS' | translate }}</th>
            <th>{{ 'SETTINGS.MESSAGE_TEMPLATES.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (template of messageTemplatesValue; track template.name) {
            <tr>
              <td>
                <div class="template-name-cell">
                  @if (template.isSystemTemplate) {
                    <span class="system-badge">
                      {{ 'SETTINGS.MESSAGE_TEMPLATES.SYSTEM_TEMPLATE' | translate }}
                    </span>
                  }
                  <span>{{ template.name }}</span>
                </div>
              </td>
              <td>{{ template.description || '-' }}</td>
              <td>{{ formatTexts(template.texts) }}</td>
              <td>{{ formatParameters(template.parameters) }}</td>
              <td class="actions-cell">
                <button
                  class="btn-icon"
                  title="{{ 'SETTINGS.MESSAGE_TEMPLATES.EDIT_TEMPLATE' | translate }}"
                  (click)="editMessageTemplate(template)">
                  <fa-icon [icon]="editIcon" class="edit-icon"></fa-icon>
                </button>
                <button
                  class="btn-icon"
                  title="{{ 'SETTINGS.MESSAGE_TEMPLATES.DELETE_TEMPLATE' | translate }}"
                  (click)="deleteMessageTemplate(template)"
                  [disabled]="template.isSystemTemplate">
                  <fa-icon [icon]="deleteIcon" class="delete-icon"></fa-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- No templates message -->
  @if (
    !loadingValue && !errorValue && messageTemplatesValue && messageTemplatesValue.length === 0
  ) {
    <div class="empty-state">
      <p>{{ 'SETTINGS.MESSAGE_TEMPLATES.NO_TEMPLATES' | translate }}</p>
    </div>
  }
</div>
